import { AccountAboutCard } from '@playbooks/components/account/account-about-card';
import { AccountNavigationList } from '@playbooks/components/account/account-navigation-list';

const AccountSlideAbout = ({ account, accountType, profileHref, target, onView, onLogout }) => {
	// Render
	return (
		<>
			<div className='border-b border-border p-4'>
				<AccountAboutCard
					account={account}
					accountType={accountType}
					href={profileHref}
					onClick={() => onView('select')}
				/>
			</div>
			<div className='min-h-0 flex-1 overflow-y-auto'>
				<AccountNavigationList signedIn profileHref={profileHref} target={target} onView={onView} onLogout={onLogout} />
			</div>
		</>
	);
};

export { AccountSlideAbout };
